export const glsl = (strings: TemplateStringsArray, ...values: unknown[]): string => {
  let result = strings[0]!;
  for (let i = 0; i < values.length; i++) {
    result += String(values[i]) + strings[i + 1]!;
  }
  return result;
};
